module.exports = __webpack_public_path__ + "img/newspaper.d0ddfcb0.svg";